

export const API_END_POINTS = {
    login: `/Authenticate`,
    forgotPassword: `/ForgotPasswordRequest`,
    createUser: `/CreateUserAccount`,
    updateUser: `/UpdateUserAccount`,
    getAllUsers: `/GetAllUserAccounts`,
    getAllUserAccountsExcelExportReport: `/GetAllUserAccountsExcelExportReport`,
    getSingleUser: `/GetUserAccountDetailByID`,
    activeAndInActiveUser: `/ActivateDeactivateUserAccount`,
    changePassword: `/ChangePassword`,
    updatePassword: `/UpdatePassword`,
    updateUserCCRequest: `/UpdateUserCCRequest`,
    passwordTokenValidate: `/PasswordTokenValidate`,
    getAllUserWithName: `/GetAllUserNameWithId`,
    userFilterByDepAndDesig: `/GetUserAccountsFilteredDepartmentAndDesignation`,
    getAllManagers: `/GetAllManagers`,
    getManagerTeam: `/GetManagerTeam`,
    getCCCardRequestedUser: `/GetCCCardRequestedUser`,
    getCreditCardRequestedUsers: `/GetCreditCardRequestedUsers`,
    getCreditCardRequestedUserDetail: `/GetCreditCardRequestedUserDetail`,
    getUserImpersonateTableData: '/GetImpersonateTeam',
    updateProfileImage: `/AddAndUpdateProfile`,
    ImpersonateUser: `/ImpersonateUser`,
    managerUsers: `/GetManagerTeamLookup`,
    renewToken: `/RenewToken`,
    userPreferences: `/SetUserPreferences`,
    updateUserPreferences: `/UpdateUserPreferences`,
    getUserPreferences: `/GetUserPreferences`,
    userAccountDetailById: `/GetUserAccountCompleteDetailByID`,
    logout: `/Logout`,
    allManagersAndAdmins: `/GetAllManagersAndAdmins`,
    getIsTravelModuleAccessAvailable: `/GetIsTravelModuleAccessAvailable`,
    getReceiptVaultUploadRules: `/GetReceiptVaultUploadRules`,
    acknowledgeReceiptVaultRules: `/AcknowledgeReceiptVaultRules`,
    getOnlyUser: `/GetOnlyUser`,
    approvalUserDraft: `/approvalUserDraft`,
    updateRequestUserStatus: `/updateRequestUserStatus`,
    getAllUsersLookupFilteredWorkFlowUsers: `/GetAllUsersLookupFilteredWorkFlowUsers`,
    deleteUserAccountImg: `/deleteUserAccountImg`,
    updateUserBasicInfo: `/UpdateUserBasicInfo`,
    getAllDelegateManager: `/GetAllDelegateManager`,
    updateUserEmail: `/UpdateUserEmail`,
    createUserRequest: `/CreateUserRequest`,
    createUserDraftByManager: `/CreateUserDraftByManager`,
    // ----------organization EndPoints--------------
    getAllOrganization: `/GetAllOrganization`,
    getOrganizationDetailByID: `/GetOrganizationDetailByID`,
    createOrganization: `/CreateOrganization`,
    updateOrganization: `/UpdateOrganization`,
    getAllRoles: `/GetAllRoles`,
    createRole: `/CreateRole`,
    updateRole: `/UpdateRole`,
    createOrganizationWorkflow: `/CreateOrganizationWorkflow`,
    updateOrganizationOnboardingStatus: `/UpdateOrganizationOnboardingStatus`,
    // ----------budget EndPoints--------------
    createBudget: `/CreateUserBudget`,
    updateUserBudget: `/UpdateUserBudget`,
    managerTeamBudget: `/GetBudgetManagerTeam`,
    budgetHistory: `/GetBudgetHistoryOfUser`,
    latestBudget: `/GetLatestBudgetOfUser`,
    remaningBudget: `/GetRemainingBudgetOfUser`,
    getRemainingBudgetOfUserV2: `/GetRemainingBudgetOfUserV2`,
    budgetSubHistory: `/GetBudgetHistory`,
    createCatagoryBudgetAllocation: `/CreateCatagoryBudgetAllocation`,
    updateCatagoryBudgetAllocation: `/UpdateCatagoryBudgetAllocation`,
    getCatagoryBudgetAllocation: `/GetCatagoryBudgetAllocation`,
    activeOrInactiveCatagoryBudgetStatus: `/ActiveOrInactiveCatagoryBudgetStatus`,
    getRemainingCatagoryBudgetOfUser: `/GetRemainingCatagoryBudgetOfUser`,
    // ----------Dashboard EndPoints--------------
    totalActiveOrg: `/GetTotalAndActiveOrg`,
    totalActiveUsers: `/GetTotalAndActiveUser`,
    newInprogressOrg: `/GetNewAndInProgressOrg`,
    userGraphData: `/GetDashboardUserGraphData`,
    totalExpenseProfile: `/GetTotalExpenseAmountsForProfile`,
    expenseDataForUserGraph: `/GetUserExpenseDataForGraph`,
    expenseAmountForProfile: `/GetTotalExpenseAmountsForProfile`,
    managerDashboardData: `/GetManagerDashboardData`,
    adminDashboardData: `/GetAdminDashboardData`,
    userDashboardData: `/GetUserDashboardData`,
    getAPDashboardData: `/GetAPDashboardData`,
    getDashboardData: `/GetDashboardData`,
    getSupperAdminDashboardData: `/getSupperAdminDashboardData`,
    // ----------Expense EndPoints--------------
    createExpense: `/CreateExpense`,
    expenseByUser: `/GetExpensesByUser`,
    expenseItemById: `/GetExpenseItemsByExpenseId`,
    updateExpenseWithItem: `/UpdateExpenseWithItems`,
    deleteExpenseItem: `/DeleteExpenseItem`,
    updateExpenseItem: `/UpdateExpenseItem`,
    updateExpenseStatus: `/UpdateExpenseStatus`,
    expensesOfManagerTeam: `/GetExpensesOfManagerTeam`,
    expenseLog: `/GetExpenselog`,
    calculateDistance: `/CalculateDistance`,
    getMileage: `/GetMileage`,
    addUpdateMileage: `/AddUpdateMileage`,
    getCardExpenseItems: `/GetCardExpenseItems`,
    addUpdateExpenseItem: `/AddUpdateExpenseItem`,
    assignItemToNewExpense: `/AssignItemToNewExpense`,
    assignItemToExistingExpense: `/AssignItemToExistingExpense`,
    getExpenseToAddItems: `/GetExpenseToAddItems`,
    getExpenseForReport: `/GetExpenseForReport`,
    addClarificationNote: `/AddClarificationNote`,
    getMileagebyDate: `/GetMileagebyDate`,
    getExpensesForAP: `/GetExpensesForAP`,
    updateExpenseStatusToAccountsPayable: `/UpdateExpenseStatusToAccountsPayable`,
    updateExpenseToSpecificAP: `/UpdateExpenseToSpecificAP`,
    upsertExpenseViolation: `/UpsertExpenseViolation`,
    getExpenseApproversByExpenseId: `/GetExpenseApproversByExpenseId`,
    getExpenseItemsByExpenseItemId: `/GetExpenseItemsByExpenseItemId`,
    recallExpenseReport: `/RecallExpenseReport`,
    mergeLineItems: `/MergeLineItems`,
    // #region MergeLineItems V1
    userMergeLineItems: `/UserMergeLineItems`,
    userUnMergeLineItems: `/Undo_MergeLineItems`,
    // #endregion MergeLineItems V1
    // #region MergeLineItems V2
    userMergeLineItemsV2: `/UserMergeLineItemsV2`,
    userMergeSSLineItemsV2: `/UserMergeSSLineItemsV2`,
    getSSLineItemsForMergeV2: `/GetSSLineItemsForMergeV2`,
    getBankLineItemsForMergeV2: `/GetBankLineItemsForMergeV2`,
    // #endregion MergeLineItems V2
    reAssignExpenseToOtherManager: `/ReAssignExpenseToOtherManager`,
    getExpenselogDetail: `/GetExpenselogDetail`,
    updateExpenseStatusToPaid: `/UpdateExpenseStatusToPaid`,
    addExpenseItemPendinCC: `/AddExpenseItemPendinCC`,
    getExpenseApproversByExpenseIdV2: `/GetExpenseApproversByExpenseIdV2`,
    getExpensesOfProviders: `/GetExpensesOfProviders`,
    createExpenseForWeb: `/CreateExpenseForWeb`,
    addUpdateExpenseItemV2Web: `/AddUpdateExpenseItemV2Web`,
    deleteExpense: `/DeleteExpense`,
    unlinkLineItemFromER: `/UnlinkLineItemFromER`,
    getReassignExpense: `/GetReassignExpense`,
    getExpensesOfDeletegateManagerTeam: `/GetExpensesOfDeletegateManagerTeam`,
    // ----------FamilyMember EndPoints--------------
    getFamilyMemberUsers: `/GetFamilyMemberByUser`,
    createFamilyMember: `/CreateFamilyMembver`,
    updateFamilyMember: `/UpdateFamilyMember`,
    deleteFamilyMember: `/DeleteFamilyMember`,
    getApprovedFamilyMemberByUser: `/GetApprovedFamilyMemberByUser`,
    // ----------ReportAnalytics EndPoints--------------
    getExpenseSummaryByUserId: `/GetExpenseSummaryByUserId`,
    getExpenseByCategory: `/GetExpenseByCategory`,
    getExpenseByPaymentMethod: `/GetExpenseByPaymentMethod`,
    getExpenseApproverSummery: `/GetExpenseApproverSummery`,
    getExpenseReportByUser: `/GetExpenseReportByUser`,
    getExpenseReportByDepartment: `/GetExpenseReportByDepartment`,
    getExpenseReportByStatus: `/GetExpenseReportByStatus`,
    getExpenseReportByPayment: `/getExpenseReportByPayment`,
    getExpenseReportByDepartmentWithAmount: `/GetExpenseReportByDepartmentWithAmount`,
    getExpenseReportByUserWithAmount: `/GetExpenseReportByUserWithAmount`,
    getExpensesReportByUser: `/GetExpensesReportByUser`,
    getReportIronePDF: `/GetReportIronePDF`,
    getReport: `/GetReport`,
    getExpenseReportByPaymentV2: `/GetExpenseReportByPaymentV3`,
    getExpensesReportByUserV2: `/GetExpensesReportByUserV2`,
    getExpenseByCategoryV2: `/GetExpenseByCategoryV2`,
    getExpenseReportByDepartmentAndUser: `/GetExpenseReportByDepartmentAndUser`,
    getExpenseViolationReport: `/GetExpenseViolationReport`,
    getExpenseCatagoryBudgetReport: `/GetExpenseCatagoryBudgetReport`,
    expenseItemsViewReportExport: `/ExpenseItemsViewReportExport`,
    expenseItemsViewtExcelExportReport: `/ExpenseItemsViewtExcelExportReport`,
    getBCSyncDataExport: `/GetBCSyncDataExport`,
    getBankFilesLineitemsV2Excel: '/GetBankFilesLineitemsExportExcelReport',
    getReportSSAndBCDataMatch: `/GetReportSSAndBCDataMatch`,
    getBCSyncData: `/GetBCSyncData`,
    getSSToBCSyncFeedsReport: `/GetSSToBCSyncFeedsReport`,
    getSSToBCSyncFeedsReportDetail: `/GetSSToBCSyncFeedsReportDetail`,

    // ----------Vendor & Card EndPoints--------------
    getAllVendor: `/GetAllVendor`,
    addVendor: `/AddVendor`,
    updateVendor: `/UpdateVendor`,
    getAllVendorLookUp: `/GetAllVendorLookUp`,
    changeVendorStatus: `/ChangeVendorStatus`,
    addCreditCardInfo: `/AddCreditCardInfo`,
    updateCreditCardInfo: `/UpdateCreditCardInfo`,
    getAllCreditCardInfo: `/GetAllCreditCardInfo`,
    getAllCreditCardTypeLookUp: `/GetAllCreditCardTypeLookUp`,
    changeCreditCardInfoStatus: `/ChangeCreditCardInfoStatus`,
    getAllCreditCardCatagoryLookUp: `/GetAllCreditCardCatagoryLookUp`,
    getAllCreditCardStatusLookUp: `/GetAllCreditCardStatusLookUp`,
    // ----------workflow EndPoints--------------
    getWorkflow: `/GetWorkflow`,
    getWorkflowByWorkflowId: `/GetWorkflowByWorkflowId`,
    createWorkflow: `/CreateWorkflow`,
    updateWorkflowWithApprovers: `/UpdateWorkflowWithApprovers`,
    getUserNotification: `/GetUserNotification`,
    getUserNotificationCount: `/GetUserNotificationCount`,
    getExpenseToApprove: `/GetExpenseToApprove`,
    getExpenseToApproveByExpenseId: `/GetExpenseToApproveByExpenseId`,
    updateStatusToApproveExpense: `/UpdateStatusToApproveExpense`,
    getWorkflowByUserAccountId: `/GetWorkflowByUserAccountId`,
    activeOrInactiveWorkflowStatus: `/ActiveOrInactiveWorkflowStatus`,
    getWorkflowApprovers: `/GetWorkflowApprovers`,
    updateStatusToApproveExpenseV2: `/UpdateStatusToApproveExpenseV2`,
    // ------------Categories EndPoint ----------
    getAllExpenseCategory: `/GetAllExpenseCategory`,
    updateExpenseCategory: `/UpdateExpenseCategory`,
    createExpenseCategory: `/CreateExpenseCategory`,
    activeInActiveExpenseCategory: `/ActiveInActiveExpenseCategory`,
    // ----------general EndPoints--------------
    getAllFamilyRelationship: `/GetAllFamilyRelationship`,
    getAllFamilyMemberStatus: `/GetAllFamilyMemberStatus`,
    getAllExpenseCategoryLookup: `/GetAllExpenseCategory`,
    getAllExpenseCategoryLookupV2: `/GetAllExpenseCategoryV2`,
    getExpenseSubCategory: `/GetExpenseSubCategory`,
    getAllCurrency: `/GetAllCurrency`,
    getAllExpenseStatus: `/GetAllExpenseStatus`,
    getAllDepartment: `/GetAllDepartment`,
    getAllDepartmentV2: `/GetAllDepartmentV2`,
    getAllDesignation: `/GetAllDesignation`,
    getAllDesignationV2: `/GetAllDesignationV2`,
    getAllExpenseItemType: `/GetAllExpenseItemType`,
    getAllWorkflowApproverStatus: `/GetAllWorkflowApproverStatus`,
    getManagerTeamLookup: `/GetManagerTeamLookup`,
    getAllExpensePaymentMethods: `/GetAllExpensePaymentMethods`,
    getAllProjectStatus: `/GetAllProjectStatus`,
    getAllClientsLookup: `/GetAllClientsLookup`,
    getAllCategory: `/GetAllCategory`,
    updateAllCategory: `/UpdateAllCategory`,
    getAllExpenseType: `/GetAllExpenseType`,
    getAllDesignationWithoutRole: `/GetAllDesignationWithoutRole`,
    configCategoryUserLevel: `/ConfigCategoryUserLevel`,
    getConfigCategoryByUser: `/GetConfigCategoryByUser`,
    updateUserCategory: `/UpdateUserCategory`,
    getAllNotificationPreferences: `/GetAllNotificationPreferences`,
    getAllDistancePreferences: `/GetAllDistancePreferences`,
    getDefaultApproversPolicyModeLookup: `/GetDefaultApproversPolicyModeLookup`,
    getAllOganizationLookup: `/GetAllOganizationLookup`,
    getOnboardingStatusLookup: `/GetOnboardingStatusLookup`,
    // createExpenseCategory: `/CreateExpenseCategory`,
    // updateExpenseCategory: `/UpdateExpenseCategory`,
    getAllLst_UserExpenseType: `/GetAllLst_UserExpenseType`,
    getAllLocations: `/GetAllLocations`,
    getAllLocationsV2: `/GetAllLocationsV2`,
    getAllLocationType: `/GetAllLocationType`,
    getAllTripType: `/GetAllTripType`,
    getDistanceByTripType: '/GetDistanceByTripType',
    getAllCity: `/GetAllCity`,
    getAllCountries: `/GetAllCountry`,
    getAllDivisionLookup: `/GetAllDivision`,
    getAllDivisionLookupV2: `/GetAllDivisionV2`,
    getViolationPolicyTypeLookup: `/GetViolationPolicyTypeLookup`,
    getDistanceDataByTripType: `/GetDistanceDataByTripType`,
    getEmailSenderType: `/GetEmailSenderType`,
    getSupportUserLookup: `/GetSupportUserLookup`,
    getSupportRequestStatusLookup: `/GetSupportRequestStatusLookup`,
    getAppRequestSeverityLookup: `/GetAppRequestSeverityLookup`,
    getAppResolutionTypeLookup: `/GetAppResolutionTypeLookup`,
    getAllLookupsCacheList: `/GetAllLookupsCacheList`,
    clearAlllLookupsCache: `/ClearAlllLookupsCache`,
    getOcrReadStatusLookup: `/GetOcrReadStatusLookup`,
    getAllDepartmentByManager: `/GetAllDepartmentByManager`,
    getUsersByManagerId: `/GetUsersByManagerId`,
    getAllManagersLookup: `/GetAllManagers`,
    getReportExpenseStatus: `/GetReportExpenseStatus`,
    getAllUsersLocation: `/GetAllUsersLocation`,
    getAllUsersLookup: `/GetAllUsersLookup`,
    getAllEmailLogs: `/GetAllEmailLogs`,
    getEmailLogById: `/GetEmailLogById`,
    getDistinctEmailToLookup: `/GetDistinctEmailToLookup`,
    getAllTimeZone: `/GetAllTimeZone`,
    getAllTimeZoneV2: `/GetAllTimeZoneV2`,
    getAllUsersManagerAdmin: `/GetAllUsersManagerAdmin`,
    getAllCCFeedFile: `/GetAllCCFeedFile`,
    getPermissionsList: `/GetPermissionsList`,
    getAllUserTypeLookup: `/GetAllUserTypeLookup`,
    getAllRecordSourceLookup: `/GetAllRecordSourceLookup`,
    getDelegateManagersLookup: `/GetDelegateManagersLookup`,
    getReportUsersByManagerId: `/GetReportUsersByManagerId`,
    // ----------micro services EndPoints--------------
    uploadFileToAzure: `/UploadFileToServer`,
    deleteFileToAzureServer: `/DeleteFileToServer`,
    getOCRvalueByfileURL: `/GetOCRvalueByfileURL`,
    uploadOCRInvoice: `/UploadOCRInvoice`,
    uploadOCRInvoices: `/UploadOCRInvoices`,
    UploadOCRInvoicesLatest: `/UploadOCRInvoicesLatest`,
    UploadReceiptsForUser: `/UploadReceiptsForUser`,
    GetInvoiceDetailById: `/GetInvoiceDetailById`,
    uploadOCRInvoiceWithItemsId: `/UploadOCRInvoiceWithItemsId`,
    automationCreditCardFeedsFilesManualCall: `/AutomationCreditCardFeedsFilesManualCall`,
    automationCreaditCardFeedsToLineItemManualCall: `/AutomationCreaditCardFeedsToLineItemManualCall`,
    automationCreaditCardFeedsToCreateExpReportManualCall: `/AutomationCreaditCardFeedsToCreateExpReportManualCall`,
    syncAllBCExpensesStatusToSSManualCallV2: `/SyncAllBCExpnesesStatusToSSManuallCall_V2`,
    clearCache: `/ClearCache`,
    validateBCGraphAPIBearerToken: `/ValidateBCGraphAPIBearerToken`,
    updateBCGraphAPIBearerToken: `/UpdateBCGraphAPIBearerToken`,
    getBCGraphAPIBearerToken: `/GetBCGraphAPIBearerToken`,
    expenseLifecycleCountSupportAndSSDevTeamDaily: `/ExpenseLifecycleCount_SupportAndSSDevTeam_Daily`,
    uploadFileToServerForSupportAttachment: `/UploadFileToServerForSupportAttachment`,
    readDraftInvoices: `/ReadDraftInvoices`,
    uploadFileWithoutOCR: `/uploadFileWithoutOCR`,
    deleteReceiptByExpenseItemId: `/DeleteReceiptByExpenseItemId`,
    // ----------DraftApi EndPoints--------------
    getAllUserDraft: `/GetAllUserDraft`,
    updateUserDraft: `/UpdateUserDraft`,
    getUserDraftById: `/GetUserDraftById`,
    activateUserDraft: `/ActivateUserDraft`,
    getAllDraftInvoices: `/GetAllDraftInvoices`,
    getAllDraftInvoicesAdmin: `/GetAllDraftInvoicesForAdmin`,
    deleteReceiptById: `/DeleteReceiptById`,
    getAllPendingRequestedUser: `/GetAllPendingRequestedUser`,
    // ----------OrgSettingApi EndPoints--------------
    getAllCountry: `/GetAllCountry`,
    addCountry: `/AddCountry`,
    updateCountry: `/UpdateCountry`,
    getCountryById: `/GetCountryById`,
    changeCountryStatus: `/ChangeCountryStatus`,
    getAllDepartmentLocation: `/GetAllDepartmentLocation`,
    addDepartmentLocation: `/AddDepartmentLocation`,
    updateDepartmentLocation: `/UpdateDepartmentLocation`,
    getDepartmentLocationById: `/GetDepartmentLocationById`,
    changeDepartmentLocationStatus: `/ChangeDepartmentLocationStatus`,
    getAllDivision: `/GetAllDivision`,
    addDivision: `/AddDivision`,
    updateDivision: `/UpdateDivision`,
    getDivisionById: `/GetDivisionById`,
    changeDivisionStatus: `/ChangeDivisionStatus`,
    getAllExpenseTypeCodes: `/GetAllExpenseTypeCodes`,
    addExpenseTypeCodes: `/AddExpenseTypeCodes`,
    updateExpenseTypeCodes: `/UpdateExpenseTypeCodes`,
    getExpenseTypeCodesById: `/GetExpenseTypeCodesById`,
    changeExpenseTypeCodesStatus: `/ChangeExpenseTypeCodesStatus`,
    getAllActiveExpenseViolations: `/GetAllActiveExpenseViolations`,
    addActiveExpenseViolations: `/AddActiveExpenseViolations`,
    updateActiveExpenseViolations: `/UpdateActiveExpenseViolations`,
    getActiveExpenseViolationsById: `/GetActiveExpenseViolationsById`,
    changeActiveExpenseViolationsStatus: `/ChangeActiveExpenseViolationsStatus`,
    getActiveExpenseViolationsByExpenseId: `/GetActiveExpenseViolationsByExpenseId`,
    getAllDepartmentList: `/GetAllDepartment`,
    addDepartment: `/AddDepartment`,
    updateDepartment: `/UpdateDepartment`,
    getDepartmentById: `/GetDepartmentById`,
    changeDepartmentStatus: `/ChangeDepartmentStatus`,
    getAllDesignationList: `/GetAllDesignation`,
    addDesignation: `/AddDesignation`,
    updateDesignation: `/UpdateDesignation`,
    getDesignationById: `/GetDesignationById`,
    changeDesignationStatus: `/ChangeDesignationStatus`,
    getAllRequestLogs: `/GetAllRequestLogs`,
    getOldRequestLogsCount: `/GetOldRequestLogsCount`,
    clearOldRequestLogs: `/ClearOldRequestLogs`,
    getAllLogFiles: `/GeAlltLogFiles`,
    cloneTodayLogFile: `/CloneTodayLogFile`,
    cloneLogFileByName: `/CloneLogFileByName`,
    downloadLogFileByName: `/DownloadLogFileByName`,
    downloadLogFilesZip: `/DownloadLogFilesZip`,
    getLogFolderInfo: `/GetLogFolderInfo`,
    getAllOrgSettingGroup: `/GetAllOrgSettingGroup`,
    getAllOrgSettings: `/GetAllOrgSettings`,
    addOrgSettingGroup: `/AddOrgSettingGroup`,
    updateOrgSettingGroup: `/UpdateOrgSettingGroup`,
    changeOrgSettingGroupStatus: `/ChangeOrgSettingGroupStatus`,
    upsertOrgSetting: `/UpsertOrgSetting`,
    refreshOrgSettingKeyCache: `/RefreshOrgSettingKeyCache`,
    // ----------OrgSettingApi EndPoints--------------
    getAllViolationPolicyField: `/GetAllViolationPolicyField`,
    addViolationPolicyField: `/AddViolationPolicyField`,
    updateViolationPolicyField: `/UpdateViolationPolicyField`,
    getViolationPolicyFieldById: `/GetViolationPolicyFieldById`,
    getExpenseViolationsByExpenseId: `/GetExpenseViolationsByExpenseId`,
    changeViolationPolicyFieldStatus: `/ChangeViolationPolicyFieldStatus`,
    getAllLocation: `/GetAllLocation`,
    addLocation: `/AddLocation`,
    updateLocation: `/UpdateLocation`,
    changeLocationStatus: `/ChangeLocationStatus`,
    getAutomationBankFilesFeedParsingStats: `/GetAutomationBankFilesFeedParsingStats`,
    // ---------automation api -----------
    getAllBankFilesLineItems: `/GetAllBankFilesLineitems`,
    getBankFilesLineitemsV2: `/GetBankFilesLineitemsV2`,
    getBankFilesLineitemsReconcilation: `/GetBankFilesLineitemsReconcilation`,
    getAllBankAndUserLineItems: `/GetAllBankAndUserLineItems`,
    getAllBankLineItems: `/GetAllBankLineItems`,
    getAllBankLineItemsOfCurrentUser: `/GetBankLineItemsByCurrentUser`,
    getAllLineItemsDraftByUser: `/GetAllLineItemsDraftByUser`,
    //----------system settings-------------
    addUpdateEmailSetting: `/AddUpdateEmailSetting`,
    getEmailSettingBySenderType: `/GetEmailSettingBySenderType`,
    getOrgServiceLookup: `/GetOrgServiceLookup`,
    getKeysandValuesOfServiceByServiceId: `/GetKeysandValuesOfServiceByServiceId`,
    addKeyAndValue: `/AddKeyAndValue`,
    updateKeyAndValue: `/UpdateKeyAndValue`,

    //--------- portal support--------------
    portalSupportRequest: `/PortalSupportRequest`,
    getAllPortalSupportRequest: `/GetAllPortalSupportRequest`,
    updatePortalSupportRequest: `/UpdatePortalSupportRequest`,
    deleteAttachmentPortalSupportRequest: `/DeleteAttachmentPortalSupportRequest`,

    //-----------BC integration---------------
    syncExpensesSSToBC: `/SyncExpensesSSToBC`,
    syncAllExpensesSSToBC: `/SyncAllExpensesSSToBC`,
    //-----------File Storage integration---------------
    getCCFeedfiles: `/GetCCFeedfiles`,
    getCCFeedMissingFiles: `/GetMissingCCFeedfiles`,
    downloadCCFeedFile: `/DownloadCCFeedFile`,
};